import React, { Component } from 'react';
import {dragPattern} from 'actions/index.js';
import { deletePattern } from "operations/actions.js";
import {setContextualHelp} from "actions/index.js";
import { connect } from "react-redux";
import {CURRENT_PATTERN_BUTTON} from 'constants/contextual-help.js';
import {PATTERN_BUTTON} from 'constants/contextual-help.js';
import {NEW_PATTERN_BUTTON} from 'constants/contextual-help.js';
import {DELETE_PATTERN_BUTTON} from 'constants/contextual-help.js';

class PatternsComponent extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            start: 0
        };
        this.operationManager = this.props.sequencerEngine.operationManager;
    }

    componentDidUpdate(prevProps) {
        let start = this.props.currentPattern - (this.props.currentPattern % 10);
        if (start !== this.state.start) {     
            this.state.start = start;
            this.setState(this.state);
        }
    }

    prev() {
        this.props.sequencerEngine.switchToPattern(this.state.start - 1);
    }

    next() {
        this.props.sequencerEngine.switchToPattern(this.state.start + 10);
    }

    hasNext() {
        return this.state.start + 10 < this.numPatterns;
    }

    hasPrev() {
        return this.state.start > 0;
    }

    onDragStart(patternNumber) {
        this.props.dragPattern(patternNumber);
    }

    deletePattern() {
        if (this.props.sequencerEngine.tracks.length === 0) {
            return;
        }

        this.operationManager.dispatch(deletePattern(
            this.props.sequencerEngine.tracks[0].currentPattern));
    }

    onDragOver(e) {
        e.preventDefault();
    }

    onDrop(patternNumber) {
        this.props.sequencerEngine.movePatternTo(this.props.patternDragging, patternNumber);
        this.setState(this.state);
    }

    clickPattern(i) {
        let state = this.props.sequencerEngine.store.getState();
        this.props.sequencerEngine.switchToPattern(i);
        this.setState(this.state);
    }

    get numPatterns() {
        return this.props.sequencerEngine.numberOfPatterns();
    }

    render() {
        if (this.props.sequencerEngine.currentSubSequence.isTrack) {
            return (
                <div></div>
            );
        }
        var patterns = [];
        for (var i=0; i < this.numPatterns; i++) {
            patterns.push(i);
        }

        patterns = patterns.slice(this.state.start, this.state.start + 10);

        return (
            <div className="patterns-container">
              {this.hasPrev() ? <div onClick={() => this.prev()} className="pag-btn">...</div> : ''}
              {patterns.map(
                  (i) =>
                      <PatternBox
                            key={i}
                            setContextualHelp={(element) => this.props.setContextualHelp(element)}
                            patternNumber={i}
                            currentPattern={this.props.currentPattern}
                            patternColor={this.props.patternColors[i]}
                            patternToEditColor={this.props.patternToEditColor}
                            onClickPattern={() => this.clickPattern(i)}
                            onDragStart={(e) => this.onDragStart(i)}
                            onDragOver={(e) => this.onDragOver(e)}
                            onDrop={(e)=>{this.onDrop(i)}}                   
                            />)
              }
              {this.hasNext() ? <div onClick={() => this.next()} className="pag-btn">...</div> : ''}
                <div
                  onMouseOver={() => this.props.setContextualHelp(NEW_PATTERN_BUTTON)}
                  onMouseLeave={() => this.props.setContextualHelp(undefined)}
                  className="new-pattern-btn" onClick={() => this.props.sequencerEngine.newPattern(true)}>+</div>
                <div
                  onMouseOver={() => this.props.setContextualHelp(DELETE_PATTERN_BUTTON)}
                  onMouseLeave={() => this.props.setContextualHelp(undefined)}
                  className="delete-pattern-btn" onClick={() => this.deletePattern()}>-</div>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    let id = props.sequencerEngine.engineId;
    let currentSubSequence = state.sequencer.currentSubSequence[id];
    let currentPattern = state.sequencer.currentPattern[currentSubSequence] || 0;
    let isPlaying = state.sequencer.isPlaying[id] || 0;
        
    return {
        midiMapMode: state.midi.midiMapMode,
        isCompactMode: state.sequencer.isCompactMode,
        resolution: state.sequencer.displayResolution,
        detailsView: state.sequencer.detailsView,
        decentralized: state.sequencer.decentralized,
        currentPattern: currentPattern,
        viewMode: state.sequencer.viewMode,
        numberOfPatterns: state.sequencer.numberOfPatterns[currentSubSequence] || 1,
        samplePack: state.sequencer.samplePack,
        patternDragging: state.sequencer.patternDragging,
        isRecordingMix: state.mix.isRecordingMix,
        isPlayingMix: state.mix.isPlayingMix,
        isPlaying: isPlaying,
        patternToEditColor: state.toolbar.patternToEditColor,
        patternColors: state.toolbar.patternColors,
        trackRolling: state.sequencer.trackRolling,
        sequenceRolling: state.sequencer.sequenceRolling,
   }
};

class PatternBox extends Component {
    render() {
        let className = 'pattern-box';
        if (this.props.currentPattern == this.props.patternNumber) {
            if (this.props.patternColor !== undefined) {
                className += ' background-' + this.props.patternColor;
            } else {
                className += ' current-pattern';
            }
        } else {
            if (this.props.patternColor !== undefined) {
                className += ' foreground-' + this.props.patternColor;
            }
        }

        if (this.props.patternNumber == this.props.patternToEditColor) {
            className += ' editing-color';
        }

        let contextualHelp = this.props.currentPattern === this.props.patternNumber ?
            CURRENT_PATTERN_BUTTON : PATTERN_BUTTON;

        return (
            <div
              onMouseOver={() => this.props.setContextualHelp(contextualHelp)}
              onMouseLeave={() => this.props.setContextualHelp(undefined)}
              onDragStart={this.props.onDragStart}
              onDragOver={this.props.onDragOver}
              onDrop={this.props.onDrop}                   
              draggable
              className={className}
              onClick={this.props.onClickPattern}>
              {this.props.patternNumber+1}             
            </div>);
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dragPattern: patternNumber => dispatch(dragPattern(patternNumber)),
        setContextualHelp: (element) => dispatch(setContextualHelp(element)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PatternsComponent);
